import { FC } from 'react';
import {
  Element,
  ElementWrapper,
  ContainerWrapper,
} from 'containers/CourtManagerAssignedExpertise/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import { injectIntl, IntlShape } from 'react-intl';

interface VictimsProps {
  intl: IntlShape;
  names: string[];
}

const renderNames = (names: string[]) => {
  return names.map(name => (
    <ElementWrapper>
      <Element elevation={3}>{name}</Element>
    </ElementWrapper>
  ));
};

const Victims: FC<VictimsProps> = props => {
  const { names } = props;
  return (
    <ContainerWrapper>
      <h2>{translate(messages.victims, props)}</h2>
      {renderNames(names)}
    </ContainerWrapper>
  );
};

export default injectIntl(Victims);
